import React, { useEffect, useState, useMemo } from "react"
import { useDispatch, useSelector } from "react-redux"
import MiniChart from "components/atoms/chart/parts/MiniChart"
import SpChart from "components/atoms/chart/parts/SpChart"
import ChartPriceDetail from "components/atoms/chart/parts/ChartPriceDetail"
import ChartLegFilter from "components/atoms/chart/parts/ChartLegFilter"
import ChartPlotFiler from "components/atoms/chart/parts/ChartPlotFilter"
import { SUB_CHART, TOOLS } from "components/atoms/chart/logic/chartConfig"
import { ChartBtn } from "components/atoms/btn"
import { changeSubChart, changeSymbol, pickArray } from "redux/ducks/Chart"
import { checkIsSp } from "utils/util"
import useChartInitialize from "components/atoms/chart/parts/useChartInitialize"
import useDruggableDialog from "components/atoms/chart/logic/useDruggableDialog"
import ChartInfoDialog from "components/atoms/chart/parts/ChartInfoDialog"
import { setTools } from "components/atoms/chart/logic/chartTools"
import ClassNames from "classnames"
import { includes, get } from "lodash"
import { useMainContents } from "components/pages/main/mainContents"

interface props {
  id?: string
  numberOfStocks?: number
  symbolDetail?: object
  notShowPriceDetail?: boolean
  movingDataItem?: {
    active: number
    changeData: Function
    total: number
    setFlag?: Function
  }
}

const MiddleChart = (props: props) => {
  const { id, numberOfStocks, movingDataItem, notShowPriceDetail } = props
  const _id = id || null
  const isPhone = checkIsSp()
  const canvasId = useChartInitialize({
    symbolData: {
      ...props.symbolDetail,
    },
    chartType: !isPhone ? "mini" : "sp",
    id: _id,
  })

  const chartInfoDialogSelector = (state: any) =>
    state.chart[canvasId].chartInfoDialog
  const plotTypeSelector = (state: any) => state.chart[canvasId].plotType
  const providersSelector = (state: any) => state.chart[canvasId].providers
  const chartInfoDialog = useSelector(chartInfoDialogSelector)
  const plotType = useSelector(plotTypeSelector)
  const providers = useSelector(providersSelector)
  const [_provider, _controller, _procs] = providers

  const [baseColor, changeBaseColor] = useState(
    document.querySelector("html").classList
  )

  const [infoDialogVisible, setInfoDialogVisible] = useState(false)
  // const infoDialogStyle = useDruggableDialog({
  //   id: "chart-info-modal",
  //   position: { top: "9.6rem", left: "1.6rem" },
  //   parentElementId: "dialog-parent",
  //   targetWidth: 200,
  //   targetHeight: 254,
  // })

  useEffect(() => {
    if (!_controller || isPhone) return
    // infoDialogVisibleがtureの時、クロスカーソルと、数値読み取りを追加する。
    setTools(
      infoDialogVisible ? pickArray([8, 0], TOOLS) : [],
      plotType.key,
      _controller
    )
  }, [infoDialogVisible])

  const { moveModal, defaultPosition, removeEvent } = useInfoDialogPosition({
    canvasId: `chart-body-${canvasId}`,
    targetId: "chart-info-modal",
    setVisible: setInfoDialogVisible,
  })

  useEffect(() => {
    if (isPhone) return
    moveModal()
    return () => removeEvent()
  }, [])

  // const dispatch = useDispatch()
  // dispatch(changeSubChart(canvasId, [SUB_CHART[11].id]))

  return (
    <>
      <div className="chart-middle-contents" id="dialog-parent">
        {!notShowPriceDetail && (
          <ChartPriceDetail
            canvasId={canvasId}
            middleChartFlag={true}
            numberOfStocks={numberOfStocks}
            movingDataItem={movingDataItem}
          />
        )}
        {!isPhone && (
          <div className="chart-filter-col">
            <ChartLegFilter canvasId={canvasId} />
            <ChartPlotFiler canvasId={canvasId} isMiddle={true} />
            <ChartBtn className="right-justify" canvasId={canvasId} />
            {/* <div
              className={ClassNames("btn btn-primary btn-chart icon-ripple")}
              onClick={() => setInfoDialogVisible(!infoDialogVisible)}
            >
              <span>
                <img
                  src={
                    includes(document.querySelector("html").classList, "dark")
                      ? TOOLS[8].icon_dark
                      : TOOLS[8].icon
                  }
                  alt={TOOLS[8].displayTitle}
                />
              </span>
            </div> */}
          </div>
        )}
        <div className="mini-chart-wrapper">
          {!isPhone ? (
            <MiniChart canvasId={canvasId} />
          ) : (
            <SpChart canvasId={canvasId} />
          )}
        </div>
        {!isPhone && (
          <div
            id="chart-info-modal"
            style={{ ...defaultPosition, zIndex: 9999 }}
          >
            {infoDialogVisible && !!get(chartInfoDialog, [0, 0], "") && (
              <ChartInfoDialog
                canvasId={canvasId}
                setVisible={setInfoDialogVisible}
                option={{ noneHeader: true }}
              />
            )}
          </div>
        )}
      </div>
    </>
  )
}

class Position {
  top: number
  bottom: number
  left: number
  right: number
  half: number
  constructor() {
    this.top = 0
    this.bottom = 0
    this.left = 0
    this.right = 0
    this.half = 0
  }
  set = (obj: object) => {
    this.top = get(obj, "top", 0)
    this.bottom = get(obj, "bottom", 0)
    this.left = get(obj, "left", 0)
    this.right = get(obj, "right", 0)
    this.half = get(obj, "half", 0)
  }
}

const useInfoDialogPosition = (props: {
  canvasId: string
  targetId: string
  setVisible?: Function
}) => {
  const { canvasId, targetId } = props
  const position = useMemo(() => {
    return new Position()
  }, [])
  const getElementRect = () => {
    const elem = document.getElementById(canvasId)
    const rect = elem && elem.getBoundingClientRect()
    const top = get(rect, "top", 0)
    const bottom = get(rect, "bottom", 0)
    const left = get(rect, "left", 0)
    const right = get(rect, "right", 0)
    return { top, bottom, left, right }
  }
  const getHalfPoint = (left: number, right: number) => {
    const half = right - left
    return left + half / 2
  }
  const { top, bottom, left, right } = getElementRect()
  const half = getHalfPoint(left, right)
  position.set({ top, bottom, left, right, half })
  const defaultPosition = {
    top,
    left,
    position: "fixed" as any,
    transition: "all 1s ease",
  }

  const onHide = (e: any) => {
    // カーソルが、チャート外にある場合ダイアログを非表示にする。
    if (!props.setVisible) return
    e.preventDefault()
    const xAxis = e.clientX
    const yAxis = e.clientY
    if (
      xAxis < position.left ||
      xAxis > position.right ||
      yAxis < position.top ||
      yAxis > position.bottom
    ) {
      props.setVisible(false)
    }
  }

  const moveModal = () => {
    // mouseMove event
    const mmove = (e: any) => {
      // canvas内にマウスが入った時、ダイアログをvisibleにする。
      props.setVisible(true)

      //同様にマウスとタッチの差異を吸収
      let event: any
      if (e.type === "mousemove") {
        event = e
      } else {
        event = e.changedTouches[0]
      }

      //フリックしたときに画面を動かさないようにデフォルト動作を抑制
      e.preventDefault()
      const xAxis = e.clientX

      // カーソルの位置が、画面の左半分か右半分かを判定し、カーソルと逆側にモーダルを表示する。
      if (targget.style.right) element.style.removeProperty("right")
      if (position.half <= xAxis) {
        targget.style.left = `${position.left}px`
      }
      if (position.half >= xAxis) {
        // 右の位置は、チャートの右からモーダルのwidthを引いた値を、leftに代入する。
        targget.style.left = `${position.right - 160}px`
      }
    }
    // mouseUp & mouseLeave event
    const mup = (e: any) => {
      //ムーブベントハンドラの消去
      document.body.removeEventListener("mousemove", mmove, false)
      document.body.removeEventListener("touchmove", mmove, false)
    }

    const element = document.getElementById(canvasId) as HTMLElement
    const targget = document.getElementById(targetId) as HTMLElement
    if (!element || !targget) return
    //ムーブイベントにコールバック
    element.addEventListener("mousemove", mmove, false)
    document.body.addEventListener("mousemove", onHide, false)
    element.addEventListener("touchmove", mmove, false)
    //マウスボタンが離されたとき、またはカーソルが外れたとき発火
    element.addEventListener("mouseleave", mup, false)
    element.addEventListener("touchleave", mup, false)
  }

  return {
    moveModal,
    defaultPosition,
    removeEvent: () =>
      document.body.removeEventListener("mousemove", onHide, false),
  }
}

export default MiddleChart
